import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { OnboardingQRModalProps } from './OnboardingQRModal';

export const openOnboardingQRModal = ({ onClose }: OnboardingQRModalProps) =>
    openPopupHelper({ popupName: popupNames.ONBOARDING_QR, onClose });

export const closeOnboardingQRModal = () => closePopupHelper(popupNames.ONBOARDING_QR);
